module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mMsUnG/tc-custom/9780470644737.jpg?1728851645790",
      "alt": "This image is the cover for the book Marketing Your Retail Store in the Internet Age"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Marketing Your Retail Store in the Internet Age\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("If you own and operate a small retail business, this guide will give you a proven system for marketing your store, allowing you to compete with online merchants and big-box stores alike. Full of fresh and innovative ideas for promoting small stores, it will show you how to create a great in-store experience and build loyal, long-lasting relationships with customers.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bob Negen, Susan Negen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("BOB NEGEN founded WhizBang! Training after owning an award-winning chain of kite stores for more than two decades. He has spent the last six years teaching other store owners and managers the nuts-and-bolts skills they need to run successful retail businesses. In his work as a speaker, author, and consultant, Bob shares the hard-earned lessons he learned along the way.   SUSAN NEGEN is cofounder of WhizBang! Training, where she takes the best of what she learned as an executive for department store giants Bloomingdales and Macys and applies it to the independent retail store.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wiley\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0